import { z } from 'zod';
import { FEEDBACK_TYPES, FEEDBACK_STATUSES } from '../constants/community.js';
export const createFeedbackSchema = z.object({
    type: z.enum(FEEDBACK_TYPES),
    title: z.string().min(1, 'Title is required').max(255),
    description: z.string().min(1, 'Description is required').max(5000),
});
export const feedbackQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    status: z.enum(FEEDBACK_STATUSES).optional(),
    type: z.enum(FEEDBACK_TYPES).optional(),
});
export const adminReplyFeedbackSchema = z.object({
    reply: z.string().min(1, 'Reply is required').max(5000),
});
export const adminUpdateFeedbackStatusSchema = z.object({
    status: z.enum(FEEDBACK_STATUSES),
});
//# sourceMappingURL=feedback.js.map